import React, { useCallback, useMemo } from 'react';
import { ComplexValue } from 'ui/common/types';
import { AccessSwitchItem } from './access-switch-item';
import { AccessSwitchProps } from './types';
import { mergeOptions } from './data';

export const AccessSwitch: React.FC<AccessSwitchProps> = ({
  options = [], invalidOptions = [],
  valueItems = [], initialValueItems = [],
  onChange, readOnly, readOnlyLabel }) => {

  const changeHandler = useCallback(
    (value: ComplexValue<number>, checked: boolean) => {

      if (checked) {
        onChange([...valueItems, value]);
      } else {
        onChange(valueItems.filter(item => item.value !== value.value));
      }
    }, [valueItems, onChange]);

  const memoizedOptions = useMemo(
    () => mergeOptions(options, initialValueItems),
    [options, initialValueItems]);

  return <>
    {memoizedOptions.map(option => {

      const disabled = !options.some(v => v.value === option.value);
      const checked = valueItems.some(v => v.value === option.value);
      const isValid = readOnly || !invalidOptions.some(invalidOption => option.value === invalidOption.value);

      return <AccessSwitchItem
        key={option.value}
        item={option}
        disabled={disabled}
        checked={checked}
        isValid={isValid}
        readOnly={readOnly}
        readOnlyLabel={readOnlyLabel}
        onChange={changeHandler}
      />;
    })}
  </>;
};
